var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isAd)?_c('GramInflowAd',{attrs:{"gram":_vm.gram,"is-omo":_vm.isOmo}}):(_vm.isSearch)?_c('GramInflowSearch',{attrs:{"gram":_vm.gram,"is-omo":_vm.isOmo}}):(_vm.isOther)?_c('GramInflowOther',{attrs:{"gram":_vm.gram,"is-omo":_vm.isOmo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }